import { LoadingOutlined } from "@ant-design/icons";

export const LoadingIcon = () => {
  return <LoadingOutlined />;
};
